import heroIllustration from "../../../images/heroIllustration.png";

const HeroSection = () => {
  return (
    <section className="relative py-20 px-6 bg-gradient-subtle overflow-hidden">
      <div className="container mx-auto max-w-6xl">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <div className="inline-block px-4 py-2 bg-accent rounded-full text-sm font-semibold text-[#ef8702]">
              DO YOU NEED HELP?
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#10281E] leading-tight">
              Hello! How Can We Help?
            </h1>
            <p className="text-lg md:text-xl text-muted-foreground max-w-lg">
              Browse through our frequently asked questions and get instant 
              customer support from our dedicated team.
            </p>
          </div>
          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-warm opacity-20 rounded-2xl blur-xl"></div>
              <img 
                src={heroIllustration} 
                alt="Customer support team illustration showing diverse support representatives"
                className="relative rounded-2xl shadow-card max-w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;